/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  HeaderService,
  IHeaderMethods,
  SettingsService,
  ISettingsMethods,
  UserListsService,
  IUserListsMethods,
  IStaticPageContentMethods,
  StaticPageContentService,
  IInviteUserMethods,
  InviteUserService,
  IDeleteUserMethods,
  DeleteUserService,
  IReInviteUserMethods,
  ReInviteUserService,
  ISuspendUserMethods,
  SuspendUserService,
  ActivateUserService,
  IActivateUserMethods,
  IMasqueraderListsMethods,
  MasqueraderListsService,
  IPresentationListsMethods,
  PresentationListsService,
  IGetOneLabelMethods,
  GetOneLabelService,
  IBoxCountUserMethods,
  BoxCountUserService,
  FeaturesFieldsUserService,
  IFeaturesFieldsUserMethods,
  MakeSectionsVIPService,
  IMakeSectionsVIPMethods,
} from "./components";

export type UsersListPageAgent = IHeaderMethods &
  ISettingsMethods &
  IStaticPageContentMethods &
  IInviteUserMethods &
  IUserListsMethods &
  IReInviteUserMethods &
  ISuspendUserMethods &
  IActivateUserMethods &
  IMasqueraderListsMethods &
  IPresentationListsMethods &
  IBoxCountUserMethods &
  IDeleteUserMethods &
  IFeaturesFieldsUserMethods &
  IGetOneLabelMethods &
  IMakeSectionsVIPMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new HeaderService(),
    new SettingsService(),
    new UserListsService(),
    new InviteUserService(),
    new DeleteUserService(),
    new FeaturesFieldsUserService(),
    new ReInviteUserService(),
    new SuspendUserService(),
    new BoxCountUserService(),
    new ActivateUserService(),
    new MasqueraderListsService(),
    new PresentationListsService(),
    new GetOneLabelService(),
    new MakeSectionsVIPService(),
  ];
};

export const getAgent = () => {
  return createAgent<UsersListPageAgent>({
    plugins: getPlugins(),
  });
};
